import React from 'react'
import qs from 'qs'
import DealerRankingStoresContainer from './dealer_ranking_stores_container'
import {
  NOIMAGE_PATH,
  PURCHASE_METHODS,
  spRankLabel,
  storePath,
  bestKaitoriHistory,
  displayPrice,
  spPriceMetaLabel,
  stars,
  formatRating,
  storeField,
  shouldShowPhone,
  callHours,
} from './dealer_ranking_redesign_utils'

function DealerRankingCard({ entry, rank, item }) {
  const store = entry.store || {}
  const contract = store.store_contract || store.storeContract || {}
  const path = storePath(store)
  const logoUrl = store.logo_url || NOIMAGE_PATH
  const rating = store.rating || 0
  const reviewCount = store.review_count || 0
  const satisfaction = Math.round((store.satisfaction_rate || 0) * 100)
  const pm = store.purchase_method || '000'
  const history = bestKaitoriHistory(entry)
  const priceLabel = displayPrice(entry, history)
  const metaLabel = spPriceMetaLabel(entry, history)

  const phoneNumber = storeField(store, 'phone_number', 'phoneNumber')
  const showPhone = shouldShowPhone(store)

  let requestBtn = null
  if (
    (contract.assessment_form || contract.assessmentForm) &&
    !(store.suspended_estimate_form ?? store.suspendedEstimateForm)
  ) {
    const query = qs.stringify({ store_id: store.id, item_id: item.id })
    requestBtn = (
      <a href={`/store_estimate_form/?${query}`} rel="nofollow" className="dealer-ranking__btn--request">
        無料で査定依頼する
      </a>
    )
  } else if (
    (contract.click_transfer || contract.clickTransfer) &&
    !(store.suspended_click_transfer ?? store.suspendedClickTransfer)
  ) {
    requestBtn = (
      <a
        href={contract.click_transfer_path || contract.clickTransferPath || path}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="dealer-ranking__btn--request"
      >
        公式サイトへ
      </a>
    )
  } else {
    requestBtn = (
      <a href={path} className="dealer-ranking__btn--request">
        詳細へ
      </a>
    )
  }

  return (
    <article className="dealer-ranking__card">
      <div className="dealer-ranking__card-header">
        <a href={path} className="dealer-ranking__card-header-link">
          <span className="dealer-ranking__rank">{spRankLabel(rank)}</span>
          <span className="dealer-ranking__store-name">{store.name}</span>
        </a>
      </div>
      <div className="dealer-ranking__card-body">
        <a href={path} className="dealer-ranking__logo">
          {store.logo_url ? (
            <img alt={store.name} src={logoUrl} loading="lazy" />
          ) : (
            <span className="dealer-ranking__logo-placeholder">業者ロゴ</span>
          )}
        </a>
        <div className="dealer-ranking__info">
          <p className="dealer-ranking__price-label">最高買取価格</p>
          <p className="dealer-ranking__price">{priceLabel}</p>
          {metaLabel ? <p className="dealer-ranking__meta">{metaLabel}</p> : null}
          <div className="dealer-ranking__rating">
            <span className="dealer-ranking__stars" aria-hidden="true">
              {stars(rating)}
            </span>
            <span className="dealer-ranking__rating-text">
              {formatRating(rating)} ({reviewCount.toLocaleString()}件) 満足度{satisfaction}%
            </span>
          </div>
          <div className="dealer-ranking__methods">
            {PURCHASE_METHODS.map((label, i) => (
              <span
                key={label}
                className={
                  pm[i] === '1'
                    ? 'dealer-ranking__method'
                    : 'dealer-ranking__method dealer-ranking__method--disabled'
                }
              >
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="dealer-ranking__actions">
        <div className="dealer-ranking__actions-inner">
          {requestBtn}
          {showPhone ? (
            <div className="dealer-ranking__call-block">
              <a
                href={`tel:${phoneNumber}`}
                className="dealer-ranking__btn--call"
                data-analytics-track-event="電話（お問い合わせ） click"
              >
                <span className="dealer-ranking__btn--call-icon i fa fa-phone-volume" aria-hidden="true" />
                <span className="dealer-ranking__btn--call-number">{phoneNumber}</span>
              </a>
              {callHours(store) ? <p className="dealer-ranking__call-note">{callHours(store)}</p> : null}
            </div>
          ) : null}
        </div>
      </div>
    </article>
  )
}

function DealerRankingRedesignView({
  item,
  prPrices,
  displayList,
  remaining,
  canCollapse,
  loading,
  currentSortKey,
  listLength,
  onSortChange,
  onLoadMore,
  onCollapse,
}) {
  let rank = 0
  const prCards = (prPrices || []).map((entry) => {
    rank += 1
    const key = entry.store && entry.store.id ? `pr-${entry.store.id}` : `rank-${rank}`
    return <DealerRankingCard key={key} entry={entry} rank={rank} item={item} />
  })

  const listCards = displayList.map((entry) => {
    rank += 1
    return (
      <DealerRankingCard key={entry.store && entry.store.id ? `${entry.store.id}-${rank}` : `rank-${rank}`} entry={entry} rank={rank} item={item} />
    )
  })

  return (
    <>
      <select className="dealer-ranking__sort" value={currentSortKey} onChange={onSortChange}>
        <option value="">▼おすすめ順</option>
        <option value="price">▼値段が高い順</option>
        <option value="review">▼評価順</option>
      </select>
      <div className="dealer-ranking__list">
        {loading && listLength === 0 ? <p className="dealer-ranking__loading">読み込み中...</p> : null}
        {prCards}
        {listCards}
      </div>
      {remaining > 0 || canCollapse ? (
        <button
          type="button"
          className="dealer-ranking__view-all"
          onClick={remaining > 0 ? onLoadMore : onCollapse}
          disabled={loading}
        >
          {loading ? '読み込み中...' : remaining > 0 ? `▼残り${remaining}社を見る` : '▲閉じる'}
        </button>
      ) : null}
    </>
  )
}

function DealerRankingRedesign(props) {
  return (
    <DealerRankingStoresContainer {...props}>
      {(viewState) => <DealerRankingRedesignView {...viewState} />}
    </DealerRankingStoresContainer>
  )
}

export default DealerRankingRedesign
